export const deliveryColumnStyle = () => ({
  '& .delivery-info.trigger-popup': {
    borderBottom: '1px dashed #0078D4',
    width: 'fit-content',
    display: 'inline',
    cursor: 'pointer',
  },
  '& .status-icon': {
    marginRight: '5px',
  },
  '& .status-error, & .iconba-ErrorBadge': {
    color: '#A80000',
  },
  '& .iconba': {
    position: 'static',
    marginLeft: '5px',
  },
  '& .status-warning, & .iconba-Warning': {
    color: '#D83B01',
  },
  '& .status-column.delivery_status_with_reject_reasons': {
    cursor: 'pointer',
  },
  // to make [sensitive content] below the Delivery Status in column direction
  '& .dashedBottomLine': {
  },
  '& .editorial-category-delivery-info': {
    borderBottom: '1px dashed',
    width: 'fit-content',
  },
  '& .sensitive-contents-text': {
    'padding-top': '5px',
  },
  '& .delivery_status_with_reject_reasons_editorial_category': {
    color: '#323130',
  },
});
